import React from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { createGlobalStyle } from 'styled-components';
import {
  VictoryBar,
  VictoryChart,
  VictoryZoomContainer,
} from 'victory';
import { getColorOrValue } from '../collectionPoolHelper';

function BcDetail({indicatorChart}) {
// Data array to get y values 
  const data = [
    { x: 'DO TP', y: getColorOrValue(indicatorChart?.dotpColor, 'value'), color: getColorOrValue(indicatorChart?.dotpColor, 'css') },
    { x: 'PR MR', y: getColorOrValue(indicatorChart?.prmrColor, 'value'), color: getColorOrValue(indicatorChart?.prmrColor, 'css') },
    { x: 'ECP', y: getColorOrValue(indicatorChart?.ecpColor, 'value'), color: getColorOrValue(indicatorChart?.ecpColor, 'css') },
    { x: 'H2S', y: getColorOrValue(indicatorChart?.h2SColor, 'value'), color: getColorOrValue(indicatorChart?.h2SColor, 'css') },
    { x: 'PLUIE', y: getColorOrValue(indicatorChart?.pluieColor, 'value'), color: getColorOrValue(indicatorChart?.pluieColor, 'css') },
    { x: 'MILIEU', y: getColorOrValue(indicatorChart?.milieuColor, 'value'), color: getColorOrValue(indicatorChart?.milieuColor, 'css') },
    { x: 'HYDRO', y: getColorOrValue(indicatorChart?.hydroColor, 'value'), color: getColorOrValue(indicatorChart?.hydroColor, 'css') },
    { x: 'INDUS', y: getColorOrValue(indicatorChart?.indusColor, 'value'), color: getColorOrValue(indicatorChart?.indusColor, 'css') },
  ];

  return (
    <div>
      <Styles />
      <div>
          {indicatorChart !== undefined && <VictoryChart
            width={700}
            height={400}
            domainPadding={25}
            containerComponent={<VictoryZoomContainer zoomDimension='x' />}
          >
            <VictoryBar
              data={data}
              cornerRadius={{ top: ({ datum }) => datum.y / 18 }}
              style={{
                data: {
                  fill: ({ datum }) =>
                    datum.color,
                  width: 30,
                },
              }}
            />
          </VictoryChart>}
      </div>
      <div>
        <div className='legend'>
          <div className='legend_color'>
            <div className='green_color'></div>
            <Word value='Peu critique' />
          </div>
          <div className='legend_color'>
            <div className='yellow_color'></div>
            <Word value='Moyennement critique' />
          </div>
          <div className='legend_color'>
            <div className='red_color'></div>
            <Word value='Très critique' />
          </div>
        </div>
        <br/>
        <div className='legend'>
          <div className='legend_color'>
            <div className='purple_color'></div>
            <Word value='Sensibilité du BC aux ECP indéterminée (V amont > V aval )' />
          </div>
        </div>
      </div>
    </div>
  );
}

const Styles = createGlobalStyle`
.legend {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .legend_color{
    display: flex;
    flex-direction: row;
    margin-right: 20px;
    align-items: center;
    .green_color, .yellow_color, .red_color, .purple_color{
      border-radius: 100%;
      width: 25px;
      height: 25px;
      margin-right: 10px;
       align-self: center;
    }
    .green_color{
      background-color: #63D1B4;
    }
    .yellow_color{
      background-color: #FFBF66;
    }
    .red_color{
      background-color: #FE3123;
    }
    .purple_color{
      background-color: #A500B5;
    }
  }
}
`;
export default BcDetail;
